import { UpdateAttendanceDepartment } from '../../../../../../../reduxToolkit/EmployeePayRoll/EmployeePayRollApi';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import ShiftTimePicker from '../ShiftTimePicker';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import CustomModal from '../../../../../../../components/Modal/CustomModal';
import moment from 'moment';
import { ErrorCode } from '../../../../../../../Apis/ErrorCode';
import {errorMsg} from "../../../../../../../Apis/functions";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 * @param show - Boolean to determine if the schedule update modal should be shown
 * @param onHide - Function to hide the modal when triggered
 * @param setModified - Function to set the updated status flag after schedule update
 * @param dataUpdate - The data to be used for updating the schedule
 */
const UpdateSchedule = ({ show, onHide, setModified, dataUpdate }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [startShiftAt, setStartShiftAt] = useState(dataUpdate.startShiftAt);
    const [endShiftAt, setEndShiftAt] = useState(dataUpdate.endShiftAt,);
    const [range, setRange] = useState(dataUpdate.range);
    const [selectedDepartment, setSelectedDepartment] = useState(dataUpdate.departmentId);

    const handleUpdate = () => {
        const body = {
            departmentId: selectedDepartment,
            id: dataUpdate.id,
            endShiftAt: endShiftAt,
            range: range,
            startShiftAt: startShiftAt,
        };

        dispatch(UpdateAttendanceDepartment(body)).then(({payload: {data: { success, code }}}) => {
                if (success === true) {
                    toast.success(t('has_been_updated_successfully'));
                    setModified(true);
                    onHide();
                } else errorMsg(code);
            },
        );
    };

    return (
        <CustomModal
            show={show}
            onHide={onHide}
            onConfirm={handleUpdate}
            title='update'
            size='lg'
            cancelButton={true}
            confirmButton={true}
        >
            <div className="row px-0">
                <ShiftTimePicker
                    startShiftAt={startShiftAt}
                    setStartShiftAt={setStartShiftAt}
                    endShiftAt={endShiftAt}
                    setEndShiftAt={setEndShiftAt}
                    range={range}
                    setRange={setRange}
                    selectedDepartment={selectedDepartment}
                    setSelectedDepartment={setSelectedDepartment}
                    displayNone={selectedDepartment === null}
                    showNoSelectionOption={false}
                />
            </div>
        </CustomModal>
    );
};

export default UpdateSchedule;
